import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useRef } from "react";
export function useWakeLock() {
  const $ = _c(5);
  const wakeLockRef = useRef(null);
  const isEnabledRef = useRef(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = async () => {
      if (typeof navigator === "undefined" || !("wakeLock" in navigator)) {
        return;
      }
      if (wakeLockRef.current && !wakeLockRef.current.released) {
        return;
      }
      wakeLockRef.current = await navigator.wakeLock.request("screen");
      isEnabledRef.current = true;
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const request = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = async () => {
      if (!wakeLockRef.current || wakeLockRef.current.released) {
        return;
      }
      await wakeLockRef.current.release();
      isEnabledRef.current = false;
      wakeLockRef.current = null;
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const release = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const handleVisibilityChange = async () => {
        if (document.visibilityState === "visible" && isEnabledRef.current) {
          ;
          try {
            await request();
          } catch (t4) {
            const error = t4;
            console.error("Failed to re-acquire wake lock:", error);
          }
        }
      };
      document.addEventListener("visibilitychange", handleVisibilityChange);
      return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        if (wakeLockRef.current && !wakeLockRef.current.released) {
          wakeLockRef.current.release().catch(_temp);
        }
      };
    };
    t3 = [request];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      request,
      release
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}
function _temp() {}